export default {
  "content": "<circle cx=\"15.998\" cy=\"15.998\" r=\"15.998\" fill=\"#CFF5D4\"/><path d=\"M12.846 16.328l1.838 2.415 4.671-4.62m3.918-5.2a6.46 6.46 0 00-.893-.067 7.571 7.571 0 01-4.463-1.35l-1.52-1.08a.685.685 0 00-.794 0l-1.487 1.046c-1.29.911-2.843 1.417-4.397 1.384-.364 0-.727 0-.992.067-.43.101-.727.506-.727.945l.463 7.794a6.987 6.987 0 002.81 5.264L16 26.3l4.727-3.374c1.686-1.215 2.711-3.172 2.81-5.264L24 9.868c0-.472-.297-.877-.727-.945z\" stroke=\"#1D1D1B\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};